export default __webpack_public_path__ + "static/media/SubImage1.8f7da973.JPG";